<script setup>
import { onMounted, ref, reactive } from 'vue'
import { areaCodeAPI, addAddressAPI, getCountryProvincesAPI, setDefaultaddressAPI, editAddressAPI, getAddressInfoAPI,getcountryCodeAPI } from '@/apis/user'
import { useI18n } from 'vue-i18n'
const { t } = useI18n();
let props = defineProps(['id'])
const emits = defineEmits(['handleClose'])

const addressRef = ref(null)
const formData = reactive({
    addressForm: {
        surname: '',
        name: '',
        mobile: '',
        country: '',
        province: '',
        city: '',
        area: '',
        zip_code: '',
        default: true,
        area_code:''
    },
})
const getinfo = async () => {
    const res = await getAddressInfoAPI({ address_id: props.id })
    if (res.code == 0) {
        if (res.data.default == 1) {
            res.data.default = true
        } else {
            res.data.default = false
        }
        formData.addressForm = res.data
    }
}
/**
 * 获取国家
 */
const areaList = ref([])
const getareaCode = async () => {
    const res = await areaCodeAPI()
    if (res.code == 0) {
        areaList.value = res.data.data
    }
}
const countries=ref([])
const countryProvinces = async () => {
    const res = await getCountryProvincesAPI()
    if (res.code == 0) {
        countries.value=res.data.countries
    }
}
const provinceList=ref([])
const changeCountry=(value)=>{
    const obj = countries.value.find(item => item.name === value);
    provinceList.value=obj.provinces
    formData.addressForm.province=''
}
const codeAll=ref()
/**
 * 获取手机号区号
 */
const countryCode=async ()=>{
    const res = await getcountryCodeAPI()
    if (res.code == 0) {
        codeAll.value = res.data.data
    }
}
const isMobile=ref(false)
const labelPosition=ref('right')
onMounted(() => {
    isMobile.value = /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
   
    if(isMobile.value==false){
        labelPosition.value='right'
    }else{
        labelPosition.value='top'
    }
    formData.addressForm={}
    countryCode();
    countryProvinces();
    if (props.id) {
        getinfo()
    }
})
const rules = {
    surname: [
        { required: true, message: t('cart40'), trigger: 'blur' }
    ],
    name: [
        { required: true, message: t('cart41'), trigger: 'blur' },

    ],
    mobile: [
        { required: true, message: t('cart42'), trigger: 'blur' }
    ],
    country: [
        { required: true, message: t('cart43'), trigger: 'blur' },

    ],
    province: [
        { required: true, message: t('cart44'), trigger: 'blur' }
    ],
    city: [
        { required: true, message: t('cart45'), trigger: 'blur' },

    ],
    area: [
        { required: true, message: t('cart46'), trigger: 'blur' },

    ],
    zip_code: [
        { required: true, message: t('cart47'), trigger: 'blur' }
    ],
    area_code:[
    { required: true, message: t('setup80'), trigger: 'blur' }
    ]

}

const addressSubmit = () => {
    addressRef.value.validate(async (valid) => {
        if (valid) {
            let isCheck = 0
            if (formData.addressForm.default) {
                isCheck = 1
            } else {
                isCheck = 2
            }
            let data = {
                sur_name: formData.addressForm.surname,
                name: formData.addressForm.name,
                mobile: formData.addressForm.mobile,
                country: formData.addressForm.country,
                province: formData.addressForm.province,
                city: formData.addressForm.city,
                area: formData.addressForm.area,
                zip_code: formData.addressForm.zip_code,
                default: isCheck,
                area_code:formData.addressForm.area_code
            }
            if (formData.addressForm.id) {
                data.address_id = formData.addressForm.id
                const res = await editAddressAPI(data)
                if (res.code == 0) {
                    ElMessage({ type: 'success', message: t('cart48') })
                    handleClose()

                } else {
                    ElMessage({ type: 'error', message: res.message })
                }
            } else {
                const res = await addAddressAPI(data)
                if (res.code == 0) {
                    ElMessage({ type: 'success', message: t('cart49') })
                    handleClose()
                } else {
                    ElMessage({ type: 'error', message: res.message })
                }
            }

        }
    })
}
const handleClose = () => {
    addressRef.value.resetFields()
    emits('handleClose',)
    formData.addressForm={}
        formData.addressForm.surname='';
        formData.addressForm.surname='';
        formData.addressForm.name='';
        formData.addressForm.mobile='';
        formData.addressForm.country='';
        formData.addressForm.province='';
        formData.addressForm.city='';
        formData.addressForm.area='';
        formData.addressForm.zip_code='';
        formData.addressForm.area_code='';
}
</script>


<template>
<div :class="isMobile?'bootomDIV':''">
    <el-form ref="addressRef" :rules="rules" :model="formData.addressForm" :label-position="labelPosition" label-width="auto" >
        <div :class="labelPosition=='top'?'topFlex':'rightFlex'">
            <el-form-item :label="t('cart50')" prop="surname">
                <el-input v-model="formData.addressForm.surname" :placeholder="t('cart50')"/>
            </el-form-item>
            <div style="width: 9px;" v-if="labelPosition=='top'"></div>
            <el-form-item :label="t('cart51')" prop="name">
                <el-input v-model="formData.addressForm.name" :placeholder="t('cart51')"/>
            </el-form-item>
        </div>
        <el-form-item :label="t('cart57')" prop="mobile">
            <el-input
           
            v-model="formData.addressForm.mobile"
            :placeholder="t('cart57')"
            clearable
          >
            <template #prepend>
                <el-form-item  prop="area_code">
              <el-select
                v-model="formData.addressForm.area_code"
                filterable
                style="width: 100px"
                :placeholder="t('setup81')"
                
              >
                <el-option
                  v-for="o in codeAll"
                  :label="`${o.code}`"
                  :value="o.code"
                  :key="o.id"
                ></el-option>
                
              </el-select> 
              </el-form-item>
            </template>
          </el-input>
           
        </el-form-item>
        <el-form-item :label="t('cart52')" prop="country">
            <el-select v-model="formData.addressForm.country" class="select-full-width"  filterable :placeholder="t('cart52')" @change="changeCountry">
                <el-option v-for="(item, i) in countries" :key="i" :label="item.name" :value="item.name" >
                    {{ item.name }}
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item :label="t('cart53')" prop="province" >
            <el-select v-if="provinceList.length>0" v-model="formData.addressForm.province" class="select-full-width" :placeholder="t('cart53')" >
                <el-option v-for="(item, i) in provinceList" :key="i" :label="item.name" :value="item.name" >
                    {{ item.name }}
                </el-option>
            </el-select>
            <el-input v-else v-model="formData.addressForm.province" :placeholder="t('cart53')"/>
        </el-form-item>
        <el-form-item :label="t('cart54')" prop="city">
            <el-input v-model="formData.addressForm.city" :placeholder="t('cart54')"/>
        </el-form-item>
        <el-form-item :label="t('cart55')" prop="area">
            <el-input v-model="formData.addressForm.area" type="textarea" :placeholder="t('cart55')"/>
        </el-form-item>
        <el-form-item :label="t('cart56')" prop="zip_code">
            <el-input v-model="formData.addressForm.zip_code" :placeholder="t('cart56')"/>
        </el-form-item>
        
        <el-form-item :label="t('cart58')" prop="default">
            <el-switch v-model="formData.addressForm.default" />
        </el-form-item>

    </el-form>
    <div :class="isMobile?'bootom':''" style="display: flex; justify-content: center;">
        <div @click="handleClose()" class="Cancel">Cancel</div>
        <div @click="addressSubmit()" class="define">{{ $t('cart37') }}</div>
       
    </div>

</div>
</template>

<style scoped lang="scss">
.define{
    background: #FB7700;
border-radius: 23px;
font-family: MicrosoftYaHei;
font-size: 14px;
color: #FFFFFF;
line-height: 19px;
text-align: left;
font-style: normal;
padding: 10px 53px;
}
.Cancel{
    font-family: MicrosoftYaHei;
font-size: 14px;
color: #333333;
line-height: 19px;
text-align: left;
font-style: normal;
border-radius: 23px;
border: 1px solid #E1E1E1;
padding: 10px 53px;
margin-right: 15px;

}
.topFlex{
    display: flex;
}
.rightFlex{
    display: flex;
    flex-direction: column;
}
.bootomDIV{
    padding-bottom: 50px;
}
.bootom{
    position: fixed;
    bottom: 0;
    left: 0;
    background-color: #ffffff;
    padding: 15px 0;
    width: 100%;
}
</style>